import React, { useState } from 'react';
import axios from 'axios';
import { useSignIn } from 'react-auth-kit';
import { useNavigate } from 'react-router-dom';
import './App.css'; // Import your CSS file

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const signIn = useSignIn();
    const navigate = useNavigate();

    const handleLogin = async () => {
        if (!username.trim() || !password.trim()) {
            setError('Please enter both username and password');
            return;
        }
        setIsLoading(true);
        setError('');
        try {
            const response = await axios.post("/login", {
                username: username.trim(),
                password,
            });
            const success = signIn({
                token: response.data.token,
                expiresIn: response.data.lifetime,
                tokenType: "Bearer",
                authState: response.data.user
            });
            if (success) {
                console.log('Login successful');
                navigate('/authgrid');
            } else {
                setError('Authentication failed. Please try again.');
            }
        } catch (err) {
            console.log('Login error:', err);
            if (err.response?.status === 401) {
                setError('Invalid username or password');
            } else if (err.response?.data?.error) {
                setError(err.response.data.error);
            } else {
                setError('Login failed. Please try again.');
            }
        } finally {
            setIsLoading(false);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        handleLogin();
    };

    return (
        <div className="fade-in">
            {/* Title Section */}
            <div className="title-style">
                <h1>Login</h1>
            </div>
            
            {/* Main Login Form */}
            <div className="main-content-style">
                <div className="player-entry-form">
                    <label className="form-label" htmlFor='username'>Username:</label>
                    <input 
                        className="form-input full-width"
                        type="text" 
                        id="username"
                        placeholder='Enter your username' 
                        value={username} 
                        onChange={(e) => setUsername(e.target.value)}
                        disabled={isLoading}
                    />
                    
                    <label className="form-label" htmlFor="password">Password:</label>
                    <input 
                        className="form-input full-width"
                        type="password" 
                        id="password"
                        placeholder='Enter your password' 
                        value={password} 
                        onChange={(e) => setPassword(e.target.value)}
                        disabled={isLoading}
                    />
                    
                    <button 
                        className={isLoading ? 'btn-loading full-width' : 'btn-standard full-width'}
                        type="button" 
                        onClick={handleSubmit}
                        disabled={isLoading}
                    >
                        {isLoading ? 'Logging in...' : 'Login'}
                    </button>
                </div>
                
                {/* Error Message */}
                {error && (
                    <div className="error-message margin-top-medium">
                        {error}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Login;
